import { render, staticRenderFns } from "./storeRank.vue?vue&type=template&id=4840746c&scoped=true&"
import script from "./storeRank.vue?vue&type=script&lang=js&"
export * from "./storeRank.vue?vue&type=script&lang=js&"
import style0 from "./storeRank.vue?vue&type=style&index=0&id=4840746c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840746c",
  null
  
)

export default component.exports